module.exports = __webpack_public_path__ + "static/ogimage-37a370736cd12463a08a510288096257.jpg";